export function isTeacherAppEnabledForPartner(partnerNumber: number | null | undefined): boolean {
  return Number.isInteger(partnerNumber) && Number(partnerNumber) > 0
}
